// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/skip-forward.js';

import { paths } from '../generated/skip-forward';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('skip-forward', Original, paths);
